import { User } from "@/types";
import { LocalStorageService } from "@/utils";

export const getParticipants = (participants: User[]) => {
  const myId = LocalStorageService.getSupportUserId();

  const me = participants.find((user) => user.id === myId)!;
  const participant = participants.find((user) => user.id !== myId)!;

  return { me, participant };
};
